import { space, tokPx } from '@sunwebgroup/ui-components'
import { Skeleton } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { Card } from './UserReview'

export const CardSkeleton = styled(Card)`
  width: 100%;
  box-shadow: none;
  padding: ${space('primitives_space_16')};
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_16')};
`

const HeadingContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const BubbleSkeleton = styled(Skeleton)`
  border-radius: ${tokPx('components_tag_m_corner_radius')};
  height: 30px;
  width: 50px;
`

export const LabelSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${space('primitives_space_16')};
`

const Rating = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_16')};
`

const DateSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${space('primitives_space_16')};
`

const ContentSkeleton = styled(Skeleton)`
  height: ${space('primitives_space_16')};
`

const FooterSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${space('primitives_space_16')};
`

export function UserReviewLoading() {
  return (
    <CardSkeleton>
      <HeadingContent>
        <Rating>
          <BubbleSkeleton />
          <LabelSkeleton />
        </Rating>
        <DateSkeleton />
      </HeadingContent>
      <ContentSkeleton />
      <ContentSkeleton />
      <FooterSkeleton />
    </CardSkeleton>
  )
}
